<script setup>
import { watch } from "vue";
import { useDraggableModal } from "@/composables/useDraggableModal";

const props = defineProps({
  show: { type: Boolean, default: false },
});

const emit = defineEmits(["close"]);

// 🔹 NOVO: arrastar o modal pelo título (não há cabeçalho próprio aqui).
// Este componente não desmonta entre aberturas (só alterna `show`), então
// recentraliza ao reabrir para a posição não persistir.
const {
  panelRef,
  panelStyle,
  isDragging,
  isDraggable,
  onHandlePointerDown,
  resetPosition,
} = useDraggableModal();

watch(
  () => props.show,
  (val) => {
    if (val) resetPosition();
  }
);

function closeModal() {
  emit("close");
}
</script>

<template>
  <div
    v-if="show"
    class="fixed inset-0 z-[9998] flex items-center justify-center bg-black/20"
    @click.self="closeModal"
  >
    <div
      ref="panelRef"
      :style="panelStyle"
      class="bg-surface rounded-lg p-4 max-w-md w-full shadow-lg max-h-[80vh] overflow-y-auto"
    >
      <h2
        class="text-xl font-semibold mb-3"
        :class="{
 'cursor-move select-none touch-none': isDraggable,
          'cursor-grabbing': isDragging,
        }"
        @pointerdown="onHandlePointerDown"
      >Sobre a seção de assuntos</h2>

      <p class="text-sm leading-relaxed text-gray-800 mb-3">
        Nesta página, organize os <strong>assuntos</strong> do sistema. Eles permitem identificar o conteúdo temático e a herança cultural dos textos cadastrados.
      </p>

      <div
        class="mb-4 rounded-md border border-blue-200 
                bg-blue-50  px-3 py-2.5"
      >
        <p class="text-sm text-blue-900 leading-relaxed">
          <strong>Dica:</strong> Enquanto o <em>Gênero</em> indica o formato (ex: Poesia), o <strong>Assunto</strong> indica o conteúdo, abrangendo <strong>temas</strong> (História, Mitologia) e <strong>contextos</strong> (Literatura Latina).
        </p>
      </div>

      <ul
        class="list-disc pl-5 text-sm text-gray-700 space-y-1.5 mb-3"
      >
        <li>
          Use o campo de busca para localizar assuntos rapidamente pelo nome.
        </li>
        <li>
          Clique em <strong>Adicionar Assunto</strong> para cadastrar um novo
          assunto com nome e descrição.
        </li>
        <li>
          Abra o menu de ações na coluna <strong>Ações</strong> para editar,
          visualizar detalhes ou excluir um assunto.
        </li>
        <li>
          Marque vários assuntos na primeira coluna para realizar
          <strong>exclusões em lote</strong> pelo menu
          <strong>Ações em lote</strong>.
        </li>
        <li>
          Clique sobre qualquer linha da tabela para abrir o
          <strong>card de detalhes</strong> do assunto.
        </li>
        <li>
          Alguns assuntos criados automaticamente pelo sistema podem ter a
          edição ou exclusão bloqueadas para preservar a consistência das
          classificações nos textos.
        </li>
      </ul>

      <div class="mt-2 text-right">
        <button
          @click="closeModal"
          class="px-3 py-1.5 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 transition"
        >
          Fechar
        </button>
      </div>
    </div>
  </div>
</template>

